__turbopack_context__.v({
  "sliderContainer": "SliderWithTicks-module-scss-module__-oeQia__sliderContainer",
  "tick": "SliderWithTicks-module-scss-module__-oeQia__tick",
  "ticksOverlay": "SliderWithTicks-module-scss-module__-oeQia__ticksOverlay",
});
